/**
 * Recipient journey, Part 8: the end of the introduction (the app's half).
 *
 * The server decides when it ends (R8.1) and says so in both payloads
 * (`care-package/open/` and `start-session/`, R8.2); the app only reads it.
 * Small pure pieces the room uses:
 *  - the one line, once, with its link to the Quest sheet (R8.3);
 *  (The store's gate is the server's unlock flag now, `nav.carats_visible`,
 *  and the trail is First Light's ticks on the Quest sky: navigation 2026-10-26.)
 */

/** The line split around its link words (R8.3). */
export function momentSegments (text = '', link = '') {
  const at = link ? text.indexOf(link) : -1
  if (at === -1) return [{ text }]
  return [
    ...(at ? [{ text: text.slice(0, at) }] : []),
    { text: link, link: true },
    ...(at + link.length < text.length ? [{ text: text.slice(at + link.length) }] : []),
  ]
}

/** The room's message for the moment the server returned, or null. */
export function momentMessage (moment) {
  if (!moment || !moment.line) return null
  return { text: moment.line, type: 'reader', _context: 'introduction-end', quest_link: moment.link || '',
           trigger: moment.trigger || '' }
}

/**
 * A room line as the gift room's steps show it (they sit over the chat, which
 * is inert under them): its text and, for the introduction's end, the link
 * words that open the Quest sheet (R8.3, R8.5).
 */
export function roomNote (m) {
  return { text: (m && m.text) || '', link: (m && m.quest_link) || '' }
}
